import React, { useEffect, useMemo, useState } from 'react';
import {
	FormItem,
	Button,
	Space,
	Modal,
	Title,
	Textbox,
	IconButton,
} from '@components';
import {
	MeetingInfo, ParticipantInfo
} from '@api';

import './ViewMeetingInfoModal.scss';
import { makeMeetingDateString } from '@common';
import { CloseIcon } from '@icons';

interface ViewMeetingInfoModalProps {
	closeModal: () => void,
	meetingInfo: MeetingInfo,
}

function ViewMeetingInfoModal(props: ViewMeetingInfoModalProps): JSX.Element {
	const {
		closeModal,
		meetingInfo,
	} = props;

	const [meetingSubject, setMeetingSubject] = useState<string>('');
	const [meetingParticipants, setMeetingParticipants] = useState<ParticipantInfo[]>([]);

	useEffect(() => {
		setMeetingSubject(meetingInfo.subject);
		setMeetingParticipants(meetingInfo.participants);
	}, [meetingInfo.subject, meetingInfo.participants]);

	const headerView = useMemo((): JSX.Element => {
		return (
			<div className="edit-meeting-info-modal__header">
				<Title trailing={<IconButton iconSize='24px' icon={<CloseIcon />} onClick={closeModal} />}>
				Информация о собрании
				</Title>
			</div>
		);
	}, [closeModal]);

	const footerView = useMemo(() => {
		return (
			<Space>
			<Button onClick={closeModal}>
				Закрыть
			</Button>
			<div></div>
		</Space>
		);
	}, [closeModal]);

	const participants = useMemo(() => {
		return meetingParticipants.map(p => (
			<Textbox
				className="participant"
				key={p.id}
				value={p.name}
				readOnly={true}
			/>
		));
	}, [meetingParticipants]);

	return meetingInfo && (
		<Modal
			className="view-meeting-info-modal"
			header={headerView}
			footer={footerView}
			isOpen
		>
			<div className="edit-meeting-info-modal__content">
				<FormItem label="Название">
					<Textbox
						value={meetingSubject}
						readOnly={true}
					/>
				</FormItem>
				<FormItem label="Дата проведения">
					<Textbox
						readOnly={true}
						value={makeMeetingDateString(meetingInfo.startUtc, meetingInfo.endUtc)}
					/>
				</FormItem>
				<FormItem label="Список участников">
					<div className="participants">{participants}</div>
				</FormItem>
			</div>
		</Modal>
	);
}

export {ViewMeetingInfoModal};